// extracted by mini-css-extract-plugin
export default {"headerBlock":"styles_headerBlock__CXN-w","backButton":"styles_backButton__OUyLp"};